module.exports = __webpack_public_path__ + "static/img/double-ramp-8m-x-8m_256.ae18327.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/double-ramp-8m-x-8m_256.png
// module id = zVhp
// module chunks = 0